import { render, staticRenderFns } from "./FileByType.vue?vue&type=template&id=b0c6a896&scoped=true&"
import script from "./FileByType.vue?vue&type=script&lang=js&"
export * from "./FileByType.vue?vue&type=script&lang=js&"
import style0 from "./FileByType.vue?vue&type=style&index=0&id=b0c6a896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c6a896",
  null
  
)

export default component.exports